import clsx from "clsx";
import styles from "../../../css/modules/toolbar.module.scss";
import { useCallback } from "react";

export const ChevronIcon = (clear, props) => {
  const onClear = useCallback(
    (e) => {
      e.stopPropagation();
      clear();
    },
    [clear]
  );
  return (
    <>
      <span
        {...props}
        onClickCapture={onClear}
        className={clsx("ico icon-cross", styles.selectIconCross, props.className)}
      />
      <span {...props} className={clsx("ico icon-chevron-down", styles.selectIcon, props.className)} />
    </>
  );
};
